import { Injectable } from '@angular/core';

const VIOLATION_WINDOW_MS = 30_000;

@Injectable({ providedIn: 'root' })
export class CspViolationService {
  private lastViolationAt: number | null = null;

  constructor() {
    if (typeof document !== 'undefined') {
      document.addEventListener('securitypolicyviolation', (event) =>
        this.recordViolation(event),
      );
    }
  }

  recordViolation(_event?: SecurityPolicyViolationEvent): void {
    this.lastViolationAt = Date.now();
  }

  recentViolation(): boolean {
    if (this.lastViolationAt === null) return false;
    return Date.now() - this.lastViolationAt <= VIOLATION_WINDOW_MS;
  }
}
